import { graphql } from "@/platform/vendure/graphql";

export const GetNewestProductsQuery = graphql(`
  query GetNewestProducts($options: ProductListOptions) {
    products(options: $options) {
      items {
        id
        name
        slug
        featuredAsset {
          id
          preview
        }
        variants {
          id
          priceWithTax
          currencyCode
        }
      }
    }
  }
`);

export const ProductCardFragment = graphql(`
  fragment ProductCard on SearchResult {
    productId
    productName
    slug
    productAsset {
      id
      preview
    }
    priceWithTax {
      __typename
      ... on PriceRange {
        min
        max
      }
      ... on SinglePrice {
        value
      }
    }
    currencyCode
  }
`);

export const GetProductDetailQuery = graphql(`
  query GetProductDetail($slug: String!) {
    product(slug: $slug) {
      id
      name
      description
      slug
      assets {
        id
        preview
        source
      }
      variants {
        id
        name
        sku
        priceWithTax
        stockLevel
        options {
          id
          code
          name
          groupId
          group {
            id
            code
            name
          }
        }
      }
      optionGroups {
        id
        code
        name
        options {
          id
          code
          name
        }
      }
      collections {
        id
        name
        slug
        parent {
          id
        }
      }
    }
  }
`);
